import React from "react";
import { Nav, Tab } from "react-bootstrap";
import TableCastinvestment from "./TableCastinvestment";
import TableKerminue from "./TableKerminue";
import TableDeltahouse from "./TableDeltahouse";
import TableNeuroninvest from "./TableNeuroninvest";
import TableAbaskhiron from "./TableAbaskhiron";
import TransactionTable from "./TransactionTable";

const Tabs = ({ transactions, onTransactionUpdated }) => {
  return (
    <div className="container mt-4">
      <Tab.Container defaultActiveKey="TransactionTable">
        <Nav variant="tabs">
          <Nav.Item>
            <Nav.Link
              eventKey="TransactionTable"
              style={{ fontWeight: "bolder", color: "black" }}
            >
              All Transactions
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="TableCastinvestment"
              style={{ fontWeight: "bolder", color: "Green" }}
            >
              Castinvestment
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="TableAbaskhiron"
              style={{ fontWeight: "bolder", color: "Blue" }}
            >
              Abaskhiron
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="TableDeltahouse"
              style={{ fontWeight: "bolder", color: "#702606" }}
            >
              Deltahouse
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="TableKerminue"
              style={{ fontWeight: "bolder", color: "#b52435" }}
            >
              Kerminue
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="TableNeuroninvest"
              style={{ fontWeight: "bolder", color: "#288f8f" }}
            >
              Neuroninvest
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content className="border p-3">
          <Tab.Pane eventKey="TransactionTable">
            <TransactionTable
              transactions={transactions}
              onTransactionUpdated={onTransactionUpdated}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="TableCastinvestment">
            <TableCastinvestment
              transactions={transactions}
              onTransactionUpdated={onTransactionUpdated}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="TableAbaskhiron">
            <TableAbaskhiron
              transactions={transactions}
              onTransactionUpdated={onTransactionUpdated}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="TableDeltahouse">
            <TableDeltahouse
              transactions={transactions}
              onTransactionUpdated={onTransactionUpdated}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="TableKerminue">
            <TableKerminue
              transactions={transactions}
              onTransactionUpdated={onTransactionUpdated}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="TableNeuroninvest">
            <TableNeuroninvest
              transactions={transactions}
              onTransactionUpdated={onTransactionUpdated}
            />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
};

export default Tabs;
